import { Tag } from 'antd'

import { connect } from '@eastcoal/formily/exports/react'
import { FormilyProps } from '@eastcoal/formily/types/component'

const Component = ({ value }: FormilyProps) => {
  return <Tag>{value}</Tag>
}

export const CurrentFieldText = connect(Component)
